import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../Button";
import WhatsappIcon from "./WhatsappIcon";

import style from "./styles.module.scss";

const keyI18n = "translations.home.whatsapp";
const whatsappUrl = "https://api.whatsapp.com/send/?phone=5585992269903";

export default function FloatingWhatsapp() {
  const { t } = useTranslation();
  const label = t(`${keyI18n}.label`);

  return (
    <div className={style.wrapper}>
      <Button
        aria-label={label}
        className={style.floatingWhatsapp}
        href={whatsappUrl}
        icon={<WhatsappIcon />}
        iconButton
        target="_blank"
        tooltip={t(`${keyI18n}.tooltip`)}
        tooltipPlacement="top-end"
        variant="tonal"
      />
    </div>
  );
}
